export const AllPermissions = {

    //Dashboard Tab
    STORE_DASHBOARD: 'G5H6I',
    STORE_INVENTORY_BIRD_EYE_VIEW_TAB: "J7K8L",
    STORE_SALES_ORDER_BIRD_EYE_VIEW_TAB: "P1Q3R",
    STORE_RECEIPTS_BIRD_EYE_VIEW_TAB: "S2T4U",
    //  END ------------------------------------------------------------->


    //  STORE  SECTION--------------------------------------------------->
    store_Un_Recognize_Tab: "D6Z5A",

    // Un_Recognize Product Tab
    store_Un_Brand: "L6B2H",

    // STORE LENS DETAILS TAB
    STORE_LENS_DETAILS_TAB:"V5W7X",

    //STORE WARRANTY DETAILS TAB
    STORE_WARRANTY_DETAILS_TAB:"Y6Z8A",

    // Un_Recognize Product Tab
    store_Un_Product: "A1B2C",
    store_Un_Sub_Product: "B2C3D",
    store_Un_Bulk_Product: "C3D4E",

    // Un_Recognize Inventory Tab
    store_Un_Inventory: "D4E5F",
    store_Un_Pending_Inventory: "E5F6G",
    store_Un_Approve_Inventory: "F6G7H",
    store_Un_Search: "G7H8I",

    // Un_Recognize Barcode TabS9T0U
    store_Un_Barcode: "H8I9J",
    store_Un_Pending_Barcode: "I9J0K",
    store_Un_Approve_Barcode: "J0K1L",
    store_Un_Price_Updated_Barcode: "K1L2M",
    store_Un_Lost_Barcode: "SU5LB",
    store_Un_Lost_Barcode_History: "YU8LH",
    store_Un_Bulk_Lost_Barcode: "BLB95",
    //  END ------------------------------------------------------------->

    //  STORE RECOGNIZE TAB ---------------------------------------------->
    store_Recognize_Tab: "L2M3N",

    // Recognize Product Tab
    store_Brand: "L6Z9H",

    // Recognize Product Tab
    store_Product: "M3N4O",

    // Recognize Inventory Tab
    store_Inventory: "N4O5P",
    store_Pending_Inventory: "O5P6Q",
    store_Approve_Inventory: "P6Q7R",
    store_Search: "Q7R8S",

    // Recognize Barcode Tab
    store_Barcode: "R8S9T",
    store_Pending_Barcode: "S9T0U",
    store_Approve_Barcode: "T0U1V",
    store_Price_Updated_Barcode: "U1V2W",
    store_Lost_Barcode: "SL89B",
    store_Lost_Barcode_History: "SB99H",
    store_Bulk_Lost_Barcode: "SOU9B",
    //  END ------------------------------------------------------------->

    //  STORE PROCUREMENT TAB ------------------------------------------->
    store_Procurement_Tab: "V2W3X",
    store_Product_List: "W3X4Y",
    store_Order_Cart: "X4Y5Z",
    store_Order_History: "Y5Z6A",
    store_Order_Received: "Z6A7B",
    store_Order_Cancelled: "A7B8C",
    //  END ------------------------------------------------------------->   

    //  STORE TRANSFER REQUESTS TAB ------------------------------------->
    store_Transfer_Requests_Tab: "B8C9D",
    store_Requested: "C9D0E",
    store_Move_Out: "D0E1F",
    store_Cancelled: "E1F2G",
    STORE_BULK_INTERNAL_TRANSFER: "SBI9T",
    store_Internal_Moved_In_Tab: "SIL5T",
    store_Internal_Moved_Out_Tab: "SIZ6T",
    //  END ------------------------------------------------------------->

    //  STORE MOVEMENT TAB ------------------------------------->
    STORE_MOVEMENT_TAB:"B9C0D",
    STORE_PENDING_MOVEMENT_TAB:"H3I4J",
    STORE_INPROCESS_MOVEMENT_TAB:"K5L6M",
    STORE_DELIVERED_MOVEMENT_TAB:"N7O8P",
    STORE_CANCELLED_MOVEMENT_TAB:"Q9R0S",
    //  END ------------------------------------------------------------->



    //  STORE TEAM ------------------------------------------------------>
    STORE_TEAM_TAB:"STT01",
    store_Staff_Tab: "F2G3H",
    store_Sub_Admin_Tab: "G3H4I",
    STORE_ROLES_TAB:"SR8PT",

    // Fitting Lab 
    STORE_FITTING_LAB: "FL09B",
    STORE_FITTING_IN_PROCESS_ORDERS: "FB97J",
    STORE_FITTING_ORDER_READY: "FB9HG",
    //  END ------------------------------------------------------------->

    //  STORE REPORT TAB  ------------------------------------------------>
    store_Report_Tab: "H4I5J",
    store_Sales_Report: "I5J6K",
    store_Sales_Return_Report: "J6K7L",
    store_Inventory_Report: "K7L8M",
    store_Daily_Activity_Report: "L8M9N",
    store_GST_OutPut_Report: "M9N0O",
    store_Inventory_Addition_Report: "N0O1P",
    store_ECom_Order_Report: "SE6OR",
    store_Collection_Report: "SC89R",

    STORE_CUSTOMER_REPORT:"T1U3V",
    STORE_INVENTORY_MOVEMENT_REPORT:"W2X4Y",
    STORE_BARCODE_AUDIT_TRAIL_REPORT:"Z5A7B",
    STORE_FEEDBACK_FORM :"C6D8E",

    //  END ------------------------------------------------------------->

    //  STORE SETTING TAB  ---------------------------------------------->
    store_Setting_Tab: "O1P2Q",
    STORE_INVOICE_SETUP_SETTING: "SGM6K",
    STORE_GREETING_MESSAGE: "SSIRG",
    STORE_ECOMMERCE_TAB:"F9G0H",
    STORE_COUPON_TAB:"L1M2N",
    STORE_LENS_VARIETY_TAB:"R3S4T",
    STORE_SKU: "ST8SU",
    //  END ------------------------------------------------------------->

    //  STORE ACCOUNTS TAB  ---------------------------------------------->
    store_Accounts_Tab: "P2Q3R",
    store_Transaction_Tab: "P1K3R",
    store_General_Accounts_Tab: "L9JJ6",
    //  END ------------------------------------------------------------->







    //DELETE PERMISSION
    // Internal Transfer Section
    // store_Internal_Transfer_Tab: "SITT1",






}